import React, { lazy, useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { showModal } from "../../utils/modalUtility";
import MasterOcassion from "./MasterOcassion";
import { useAppContext } from "../../context/AppContext";

const Master = () => {
  const [masterGifts, setMasterGifts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const { state } = useAppContext();

  const [masterGiftFormData, setMasterGiftFormData] = useState({
    gift_name: "",
  });

  const [activeTab, setActiveTab] = useState("gifts");
  const axiosAPI = useAxios();

  async function fetchMasterGift() {
    setLoading(true); // Start loading
    try {
      const res = await axiosAPI.get(`/api/gifts/get-master-gifts`);
      setMasterGifts(res.data.results);
    } catch (err) {
      console.error("Error fetching gifts:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  function handleMasterGift(e) {
    const { name, value } = e.target;
    console.log(name, value);
    setMasterGiftFormData((prev) => ({ ...prev, [name]: value }));
  }

  const handleAddGift = async () => {
    const giftName = masterGiftFormData?.gift_name?.trim();

    if (!giftName) {
      window.notifyMessage("Error", "Gift name is required", "error");
      return;
    }

    try {
      const payload = { gift_name: giftName };
      console.log("Payload", payload);

      const response = await axiosAPI.post(
        "/api/gifts/add-master-gift",
        payload
      );
      const data = response.data || [];

      // Optional: double check status code
      if (![200, 201].includes(response.status)) {
        throw new Error(data.message || "Something went wrong");
      }
      // Show success message
      window.notifyMessage("Success", "Gift added successfully", "success");

      // Optionally add to frontend list (if you’re maintaining one)
      // const newGift = { id: data.giftId || Date.now(), name: giftName };
      // setGiftList((prev) => [...prev, newGift]);

      // Clear input
      fetchMasterGift();
      setMasterGiftFormData({ gift_name: "" });
    } catch (error) {
      console.error("Failed to add gift:", error.message);
      window.notifyMessage(
        "Error",
        error.message || "Failed to add gift",
        "error"
      );
    }
  };

  const handleDeleteGift = async (id) => {
    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this gift?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.delete(
        `/api/gifts/delete-master-gift/${id}`
      );
      const data = response.data;

      // Optional: double check status code
      if (![200, 204].includes(response.status)) {
        throw new Error(data.message || "Something went wrong");
      }

      window.notifyMessage("Success", "Gift deleted successfully", "success");

      setMasterGifts((prevList) => prevList.filter((gift) => gift.id !== id));

      //  Refresh the list after deletion
      // fetchMasterGift();
    } catch (error) {
      console.error("Failed to delete gift:", error.message);
      window.notifyMessage(
        "Error",
        error.message || "Failed to delete gift",
        "error"
      );
    }
  };

  function openGiftModal() {
    showModal("openMasterGiftModal");
  }

  useEffect(() => {
    fetchMasterGift();
  }, []);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    setRole(state?.user?.role);
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mb-3 gap-2">
          <div>
            {/* Nav Tabs */}
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "gifts" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("gifts")}
                >
                  Gifts
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "occasion" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("occasion")}
                >
                  Occasions
                </button>
              </li>
            </ul>
          </div>
          {activeTab === "gifts" && (
            <div>
              <button
                type="button"
                className="btn btn-success btn-round"
                onClick={openGiftModal}
              >
                Add Gifts
              </button>
            </div>
          )}
        </div>

        <div
          className="modal fade"
          id="openMasterGiftModal"
          tabIndex="-1"
          aria-labelledby="openMasterGiftModal"
          aria-hidden="true"
        >
          <div
            className={
              "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md"
            }
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="openMasterGiftModal">
                  {isEditMode ? "Edit Master Gift" : "Add Master Gift"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    // closeModal();
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {/* === Add Gift Manually === */}
                <div className="mb-4">
                  <label htmlFor="gift_name" className="form-label">
                    Gift Name
                  </label>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      id="gift_name"
                      name="gift_name"
                      className="form-control"
                      value={masterGiftFormData.gift_name}
                      placeholder="Enter gift name"
                      onChange={handleMasterGift}
                    />
                    <button
                      className="btn btn-success btn-sm"
                      onClick={handleAddGift}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {activeTab === "occasion" && (
          <MasterOcassion activeTab={activeTab} setActiveTab={setActiveTab} />
        )}

        {/* Gift table */}

        {activeTab === "gifts" && (
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <h4 className="card-title mb-0">
                    All Gifts ({masterGifts?.length})
                  </h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          {role === "admin" && (
                            <th>Action</th> // Show this if the role is "admin"
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              {/* Loading... */}
                              <div
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  zIndex: 9999,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                  style={{ width: "3rem", height: "3rem" }}
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : masterGifts.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        ) : (
                          masterGifts.map((gifts, index) => {
                            return (
                              <tr key={gifts.id}>
                                <td>{index + 1}</td>
                                <td>{gifts?.name}</td>

                                <td>
                                  <button
                                    className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                    onClick={() => handleDeleteGift(gifts.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Master;
